/* tslint:disable no-var-requires */

import 'core-js';
import 'regenerator-runtime';
import { polyfill } from './setup';

// Sentry error tracking (import early to catch all errors)
import './sentry/index';

polyfill().then(() => {
  require('./imports');
});

// Do not touch
// @ts-ignore
if (module.hot) module.hot.accept();
